import React from 'react';
import styled from 'styled-components';

const StatsWrapper = styled.section`
  width: 100%;
  max-width: 1208px;
  margin: 80px auto 0;
  padding: 32px 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 24px 16px;
    gap: 24px;
  }
`;

const StatItem = styled.div`
  text-align: center;
  max-width: 280px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const StatNumber = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: #002776;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const StatDescription = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  color: #555555;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

export default function StatsContainer() {
  return (
    <StatsWrapper>
      <StatItem>
        <StatNumber>Até 80% de economia</StatNumber>
        <StatDescription>Em consultas, exames e serviços presenciais</StatDescription>
      </StatItem>
      <StatItem>
        <StatNumber>35% de desconto</StatNumber>
        <StatDescription>Em medicamentos nas principais redes</StatDescription>
      </StatItem>
      <StatItem>
        <StatNumber>Telemedicina Einstein 24h</StatNumber>
        <StatDescription>Sem custo adicional nos planos</StatDescription>
      </StatItem>
    </StatsWrapper>
  );
}
